import React from 'react';
import styled from 'styled-components';
import { InputGroup, Overline } from '@prezi/bento';
import { createDataLookup } from '../../../const';
import { localI18n } from '../../../../i18n';
const uxCopy = {
  label: localI18n._("Link title"),
  placeholder: localI18n._("Enter the company or viewer\u2019s name for your own records")
};
const InputGroupCssOverrideWrapper = styled.div.withConfig({
  displayName: "LinkNameInput__InputGroupCssOverrideWrapper",
  componentId: "xsr9m8-0"
})(["&&& ", "{text-transform:none;}"], Overline);
const LinkNameInput = ({
  value,
  onChange
}) => React.createElement(InputGroupCssOverrideWrapper, null, React.createElement(InputGroup, {
  label: uxCopy.label,
  placeholder: uxCopy.placeholder,
  value: value,
  onChange: event => {
    const maxCharName = event.target.value.slice(0, 80);
    onChange(maxCharName);
  },
  "data-lookup": createDataLookup('link-name-input')
}));
export default LinkNameInput;